import Navbar from "../../components/Navbar/Navbar";
import LinhaDado from "../../components/LinhaDado";
import EditInstituicao from "../../components/ModalForms/EditInstituicao";
import Cabecalho from "../../components/Cabecalho";
import AddMembro from "../../components/ModalForms/AddMembro";
import EditMembro from "../../components/ModalForms/EditMembro";
import { Bars } from "react-loader-spinner";

import React, { useContext, useEffect, useState } from "react";
import { Modal } from "react-responsive-modal";
import "react-responsive-modal/styles.css";
import styles from "./styles.module.css";
import { Membro } from "../../model/Membro";
import { UserContext } from "../../context/UserContext";
import getInstituicao from "../../services/getInstituicao";
import getMembros from "../../services/getMembros";
import { Instituicao } from "../../model/Instituicao";

function Conta() {
  const [loading, setLoading] = useState(true);
  const [openAddMembro, setAddMembro] = useState(false);
  const [openEditInst, setEditInst] = useState(false);
  const [openEditBtn, setEditBtn] = useState([
    false,
    false,
    false,
    false,
    false,
  ]);

  const [userInstituicao, setInstituicao] = useState<Instituicao>();
  const [listaMembros, setListaMembros] = useState<Membro[]>([]);

  const { cnpj, token } = useContext(UserContext);

  useEffect(() => {
    const carregarDadosInstituicao = async () => {
      try {
        const responseInstituicao = await getInstituicao(token, cnpj);
        setInstituicao({
          cnpj: responseInstituicao.cnpj,
          email: responseInstituicao.email,
          nome: responseInstituicao.nome,
          telefone: responseInstituicao.telefone,
          endereco: {
            cep: responseInstituicao.cep,
            estado: responseInstituicao.estado,
            cidade: responseInstituicao.cidade,
            bairro: responseInstituicao.bairro,
            rua: responseInstituicao.rua,
            numero: responseInstituicao.numero,
            complemento: responseInstituicao.complemento,
          },
        });
        const responseMembros = await getMembros(token, cnpj);

        const membros = responseMembros.map((m: any) => {
          const membro: Membro = {
            rg: m.rg,
            orgao: m.orgao_expedidor,
            cargo: m.cargo,
            representante: m.representante,
            data_inicio_mandato: m.data_inicio_mandato
              ? new Date(m.data_inicio_mandato)
              : undefined,
            data_fim_mandato: m.data_fim_mandato
              ? new Date(m.data_fim_mandato)
              : undefined,
            endereco: {
              cep: m.cep,
              bairro: m.bairro,
              cidade: m.cidade,
              estado: m.estado,
              numero: m.numero,
              rua: m.rua,
              complemento: m.complemento,
            },
            cpf: m.user.cpf,
            nome: m.user.name,
            email: m.user.email,
          };
          return membro;
        });
        setListaMembros(membros);
        setLoading(false);
      } catch (error) {
        console.error("Dados da instituição:", error);
      }
    };
    carregarDadosInstituicao();
  }, []);

  return (
    <div className={styles.page}>
      <Navbar activeIndex={0} />
      <section>
        <Cabecalho title="Minha Conta" icon="group" />

        <main>
          {loading ? (
            <div className={styles.loading}>
              <Bars
                height="80"
                width="80"
                color="#172554"
                ariaLabel="bars-loading"
                wrapperStyle={{}}
                wrapperClass=""
                visible={true}
              />
            </div>
          ) : (
            userInstituicao && (
              <>
                <div className={styles.container}>
                  <h3>Dados da Instituição:</h3>
                  <div className={styles.container_data}>
                    <LinhaDado chave="Nome" valor={userInstituicao.nome} />
                    <LinhaDado chave="CNPJ" valor={userInstituicao.cnpj} />
                    <LinhaDado chave="Email" valor={userInstituicao.email} />
                    <LinhaDado
                      chave="Telefone"
                      valor={userInstituicao.telefone}
                    />
                    <hr />
                    <h4 className={styles.subTitulo}>Endereço:</h4>
                    <LinhaDado
                      chave="CEP"
                      valor={userInstituicao.endereco.cep}
                    />
                    <LinhaDado
                      chave="Estado"
                      valor={userInstituicao.endereco.estado}
                    />
                    <LinhaDado
                      chave="Cidade"
                      valor={userInstituicao.endereco.cidade}
                    />
                    <LinhaDado
                      chave="Bairro"
                      valor={userInstituicao.endereco.bairro}
                    />
                    <LinhaDado
                      chave="Rua"
                      valor={userInstituicao.endereco.rua}
                    />
                    <LinhaDado
                      chave="Numero"
                      valor={userInstituicao.endereco.numero}
                    />
                    {userInstituicao.endereco.complemento && (
                      <LinhaDado
                        chave="Complemento"
                        valor={userInstituicao.endereco.complemento}
                      />
                    )}
                  </div>

                  <button
                    className={styles.editButton}
                    onClick={() => setEditInst(true)}
                  >
                    Editar dados
                  </button>
                  <Modal
                    open={openEditInst}
                    onClose={() => setEditInst(false)}
                    center
                    classNames={{
                      modal: styles.customModal,
                    }}
                  >
                    <EditInstituicao
                      instituicaoObj={userInstituicao}
                      setInstituicao={setInstituicao}
                      closeModal={() => setEditInst(false)}
                    />
                  </Modal>
                </div>

                {listaMembros.map((Membro, index) => (
                  <div className={styles.container} key={index}>
                    <h3>
                      {Membro.representante
                        ? "Dados do Representante:"
                        : `Dados do Membro:`}
                    </h3>
                    <div className={styles.container_data}>
                      <LinhaDado chave="Nome" valor={Membro.nome} />
                      <LinhaDado chave="Email" valor={Membro.email} />
                      <LinhaDado chave="Cargo" valor={Membro.cargo} />
                      <LinhaDado chave="CPF" valor={Membro.cpf} />
                      <LinhaDado chave="RG" valor={Membro.rg} />
                      <LinhaDado chave="Órgão" valor={Membro.orgao} />

                      <hr />
                      <h4 className={styles.subTitulo}>Endereço:</h4>
                      <LinhaDado chave="CEP" valor={Membro.endereco.cep} />
                      <LinhaDado
                        chave="Estado"
                        valor={Membro.endereco.estado}
                      />
                      <LinhaDado
                        chave="Cidade"
                        valor={Membro.endereco.cidade}
                      />
                      <LinhaDado
                        chave="Bairro"
                        valor={Membro.endereco.bairro}
                      />
                      <LinhaDado chave="Rua" valor={Membro.endereco.rua} />
                      <LinhaDado
                        chave="Numero"
                        valor={Membro.endereco.numero}
                      />
                      {Membro.endereco.complemento && (
                        <LinhaDado
                          chave="Complemento"
                          valor={Membro.endereco.complemento}
                        />
                      )}
                    </div>
                    <button
                      className={styles.editButton}
                      onClick={() => {
                        let bolArray = [false, false, false, false, false];
                        bolArray[index] = true;
                        setEditBtn(bolArray);
                      }}
                    >
                      Editar dados
                    </button>
                    <Modal
                      open={openEditBtn[index]}
                      onClose={() =>
                        setEditBtn([false, false, false, false, false])
                      }
                      center
                      classNames={{
                        modal: styles.customModal,
                      }}
                    >
                      <EditMembro
                        listaMembros={listaMembros}
                        index={index}
                        setMembros={setListaMembros}
                        closeModal={() =>
                          setEditBtn([false, false, false, false, false])
                        }
                      />
                    </Modal>
                  </div>
                ))}

                {listaMembros.length < 5 && (
                  <button
                    className={styles.addBtn}
                    onClick={() => setAddMembro(true)}
                  >
                    Adicionar Membro
                  </button>
                )}
                <Modal
                  open={openAddMembro}
                  onClose={() => setAddMembro(false)}
                  center
                  classNames={{
                    modal: styles.customModal,
                  }}
                >
                  <AddMembro
                    listaMembros={listaMembros}
                    setMembros={setListaMembros}
                    closeModal={() => setAddMembro(false)}
                  />
                </Modal>
              </>
            )
          )}
        </main>
      </section>
    </div>
  );
}

export default Conta;
